module.exports = __webpack_public_path__ + "media/category_icons/Pediatrics-df8475b5.svg";